import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "ticketino-api-client";

import Header from "./../components/Header";
import Footer from "./../components/Footer";

const Confirmation = () => {
    const [token] = useState(sessionStorage.getItem("token"));
    const [order, setOrder] = useState([]);
    const [organizerId, setOrganizerId] = useState(0);

    const [ticketTypeIdRegister, setTicketTypeIdRegister] = useState(0);
    const [ticketTypeIdDeregister, setTicketTypeIdDeregister] = useState(0);

    // base url
    let baseUrl = process.env.REACT_APP_BASEURL_API;

    // setting the base url of the npm package api calls
    api.defaults.baseURL = baseUrl;

    // fetching resources
    const [resources, setResources] = useState({});

    // fetching resources
    const { language, orderId } = useParams();

    let languageId = 0;

    // changing languageId according to the url
    switch (language) {
        case ("de" || "DE"):
            languageId = 1;
            break;
        case ("fr" || "FR"):
            languageId = 2;
            break;
        case ("en" || "EN"):
            languageId = 3;
            break;
        case ("it" || "IT"):
            languageId = 4;
            break;
        default:
            languageId = 0;
            break;
    }

    useEffect(() => {
        //// gtm - purchase
        //window.dataLayer = window.dataLayer || [];
        //window.dataLayer.push({
        //    'event': 'purchase'
        //});

        // Scroll to the top of the page
        window.scrollTo(0, 0);
    }, [])

    useEffect(() => {
        loadToken();
    }, []); //only on first page load

    useEffect(() => {
        requestResources();
    }, [language]); //everytime language is changed

    const loadToken = async () => {
        axios.defaults.headers.common["Authorization"] = "Bearer " + token;
        api.defaults.headers.common['Authorization'] = "Bearer " + token;

        //remove orerId from session
        sessionStorage.removeItem("orderId");

        requestFormSettings()
    };

    const requestFormSettings = async () => {
        await axios.get(`form/formsettings`).then((res) => {
            setOrganizerId(res.data.organizerId);
            setTicketTypeIdRegister(res.data.registerTicketTypeId);
            setTicketTypeIdDeregister(res.data.deregisterTicketTypeId);
            loadOrder(orderId);
        });
    };

    const requestResources = async () => {
        await axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setResources(res.data.translation);
            })
            .catch((error) => console.error(error.response.data));
    };

    const loadOrder = async (orderId) => {
        try {
            // Order
            const order = await getOrderByOrderId(orderId);

            setOrder(order);
        }
        catch (error) {
            console.error(error);
        }
    }

    const getOrderByOrderId = async (orderId) => {
        try {
            const res = await axios.get(`${baseUrl}/Order/${orderId}`);
            return res.data;
        }
        catch (error) {
            console.error(error);
        }
    }

    const getPdfTicketsOfOrder = async () => {
        await axios
            .get(
                `${baseUrl}/Order/${orderId}/TicketsPdf?organizerId=${organizerId}`,
                {
                    responseType: "blob",
                }
            )
            .then((res) => {
                const data = window.URL.createObjectURL(res.data);
                var link = document.createElement("a");
                link.href = data;
                link.download = "Tickets.pdf";
                link.click();
            })
            .catch((error) => console.error(error.response.data));
    };

    // Check if order contains deregister ticket type
    const hasDeregisterTicket = () => {
        if (!order || !order.tickets || !Array.isArray(order.tickets)) {
            return false;
        }
        return order.tickets.some(ticket => ticket.ticketTypeId === ticketTypeIdDeregister);
    };

    return (
        <div>
            <Header resources={resources} title={resources?.HomeTitle} />
            <div className="container mt-5 mb-5 page-container-smaller">

                <div className="mt-5 mb-5 buyer-information-box confirmation">
                    <div className="mt-2 mb-5 text-center">
                        <p className="subtitle"><strong>{resources.ConfirmationTitle}</strong></p>
                    </div>
                    <div className="mb-3 text-center">
                        {hasDeregisterTicket() ? (
                            <p dangerouslySetInnerHTML={{ __html: resources?.ConfirmationDeregistration }}></p>
                        ) : (
                            <p dangerouslySetInnerHTML={{ __html: resources?.ConfirmationRegistration }}></p>
                        )}
                    </div>

                    <div className="row mt-5 text-center">
                        <div className="col-md-12">
                            <button
                                className="btn btn-custom btn-register"
                                style={{ minWidth: "240px" }}
                                onClick={() => getPdfTicketsOfOrder()}
                            >
                                Ticket herunterladen
                            </button>
                        </div>
                    </div>
                </div>

            </div>
            <Footer />
        </div>
    )
}

export default Confirmation